export const HEADER_ITEM_ID = {
  NOTIFICATION: 'notificationsButton',
  PROFILE: 'profileButton',
};
